const mainBabyBlue = "rgb(231,244,254)"
const navbarText = "rgb(40,40,40)"
const highlightNavbarText = "rgb(180,180,180)"
const mainBlueText = "rgb(138,189,255)"
const footerDivider = "rgb(205,226,255)"
const greyText = "rgb(150,150,150)"

export type ColorsType = {
  mainBabyBlue: string
  navbarText: string
  highlightNavbarText: string
  footerText: string
  footerDivider: string
  greyText: string
}

export const colors = {
  mainBabyBlue,
  navbarText,
  highlightNavbarText,
  mainBlueText,
  footerDivider,
  greyText,
}
